import AdminApi from '../services/api';
import swal from 'sweetalert2';
import AutocompleteObject from '../components/Shared/AutocompleteObject';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'schedule', 'vehicles'],

    data() {
        return {
            title: '',
            buttonTitle: '',
            placeholderVehicle: "Vozilo",
            newSelectedVehicle: null,
            isLoading: false,
            selectedVehicle: null,
            hasError: ''
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                if(this.schedule == null){
                    this.selectedVehicle = null;
                    this.title = "Dodaj vozilo";
                    this.buttonTitle = "Dodaj";
                }else{
                    this.selectedVehicle = this.schedule;
                    this.title = "Izmeni vozilo vozaču: " + this.schedule.courier.firstName;
                    this.buttonTitle = "Izmeni ";
                    this.plate = this.schedule.registrationPlate;
                }
            }
        },

        plate: function(val, oldVal) {
            this.hasError = '';
        },
    },
    components: { AutocompleteObject },
    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeEditScheduleVehicle')
        },
        successEdit(){
            this.reset();
            this.$topnavbar.$emit('successEditScheduleVehicle')
        },

        editPlate: editPlate,
        setNewVehicle: setNewVehicle,
        reset: reset,
    }
}

function editPlate() {
    if(this.newSelectedVehicle == null) {
        this.hasError = "Molimo izaberite vozilo";
        return;
    }

    let _self = this;
    const newModel = {
        id: _self.newSelectedVehicle.id,
        name: _self.newSelectedVehicle.vehicle,
        registrationPlate: _self.newSelectedVehicle.name,
        description: _self.newSelectedVehicle.vehicle.description,
        registrationExpiration: _self.newSelectedVehicle.registrationExpiration == null || _self.newSelectedVehicle.registrationExpiration.length === 0 ? null : _self.newSelectedVehicle.registrationExpiration,
        averageSpending: _self.newSelectedVehicle.averageSpending,
        fuel: _self.newSelectedVehicle.fuel,
        kilometersTraveled: _self.newSelectedVehicle.kilometersTraveled,
        smallService: _self.newSelectedVehicle.smallService,
        lastSmallService: _self.newSelectedVehicle.lastSmallService,
    };
    _self.isLoading = true;
    AdminApiService.editVehicleSchedule(newModel, _self.schedule.id)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successEdit();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}


function reset() {
    this.selectedVehicle = ''
    this.newSelectedVehicle = null;
    this.$topnavbar.$emit('clearACObject');
}

function setNewVehicle(event) {
    if(event == null || event.length === 0){
        this.newSelectedVehicle = null;
    }else{
        this.newSelectedVehicle = event;
    }
}


// WEBPACK FOOTER //
// ./src/modals/EditScheduleVehicleModal.js